export default "__VITE_ASSET__D6YB7$3x__"